// extracted by mini-css-extract-plugin
export default {"sandboxContainer":"Sandbox_sandboxContainer__7ikFG","pickComponentContainer":"Sandbox_pickComponentContainer__ni46Y","pickComponent":"Sandbox_pickComponent__9vdB8"};